export class LoadNoteType {

  public code: string;
  public defaultLabel: string;

  static fromDto(data: any): LoadNoteType {
    if (!data) {
      return null;
    }

    const noteType = new LoadNoteType();

    noteType.code         = data.code;
    noteType.defaultLabel = data.default_label;

    return noteType;
  }
}
